import { useCallback, useEffect, useState } from 'react';

const SCROLL_THRESHOLD = 50;
const SHORT_CONTENT_DELAY = 600;

interface Props {
  enabled: boolean;
  clipHeight: number;
  navigationKey?: string;
}

const useContentGateScroll = ({ enabled, clipHeight, navigationKey }: Props) => {
  const [showPopup, setShowPopup] = useState(false);

  const handleScroll = useCallback(() => {
    if (window.scrollY >= SCROLL_THRESHOLD) {
      setShowPopup(true);
    }
  }, []);

  useEffect(() => {
    setShowPopup(false);
  }, [navigationKey]);

  useEffect(() => {
    if (!enabled) {
      setShowPopup(false);
      return;
    }

    if (window.scrollY >= SCROLL_THRESHOLD) {
      setShowPopup(true);
      return;
    }

    // If content is too short to scroll, show popup after a brief delay
    const contentBounds = document.querySelector('.rendered-post')?.getBoundingClientRect();
    if (contentBounds) {
      const visibleHeight = window.innerHeight + clipHeight;
      if (contentBounds.top + contentBounds.height <= visibleHeight) {
        const timer = setTimeout(() => setShowPopup(true), SHORT_CONTENT_DELAY);
        return () => clearTimeout(timer);
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [enabled, clipHeight, handleScroll, navigationKey]);

  return showPopup;
};

export default useContentGateScroll;
